/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import ConverterRoutes from './converter.routes';
import ConverterDirective from './converter.directive';
import ConverterTableConfig from './converter-table.config';
import ConverterStatisticsConfig from './converter-statistics.config';

export default angular.module('tektelic.converter', [])
    .config(ConverterRoutes)
    .directive('tkConverter', ConverterDirective)
    .factory('converterTableConfig', ConverterTableConfig)
    .factory('converterStatisticsConfig', ConverterStatisticsConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/converter/index.js